export default __webpack_public_path__ + "371814d0c6e11115cd6cf302031f375a.svg";